<div class="login_container">
  <div class="login_block">
    <div class="title text_title_middle pb_35">
      {{'auth.login' | translate}}
    </div>
    <app-login></app-login>
  </div>
</div>
